export const getCity = (state) => state.search.city
